import { ShieldCheck } from 'lucide-react';
import type { WorkflowDocumentType } from '@/api/workflows.api';
import { useDocumentWorkflow } from '@/hooks/useWorkflows';
import { workflowError } from '@/features/workflow/WorkflowIntegratedPages';
import { Card } from '@/components/ui/Page';
import { WorkflowApprovalTimeline } from '@/features/workflow/ApprovalTimeline';

export function DocumentWorkflowPanel({ documentType, documentId }: { documentType: WorkflowDocumentType; documentId: string }) {
  const query = useDocumentWorkflow(documentType, documentId);
  if (query.isLoading) return <Card><div className="workflow-state">Loading approval progress…</div></Card>;
  if (query.isError) return <Card><div className="workflow-state"><ShieldCheck /><strong>No approval workflow yet</strong><span>The workflow appears after this document is submitted.</span><small>{workflowError(query.error)}</small></div></Card>;
  const instance = query.data!;
  return <WorkflowApprovalTimeline instance={instance} title="Approval history" />;
}
